"use strict";
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// @TODO: fix jsx-a11y
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKSelect = void 0;
var React = __importStar(require("react"));
var _1 = require(".");
var common_1 = require("../../common");
var hooks_1 = require("../../common/hooks");
var components_1 = require("../../components");
var Grouping_1 = require("../../models/Grouping");
require("./GKSelect.css");
var GKSelectDefinition = function (props, ref) {
    // Props
    // Some intentionally destructured from otherProps
    var bsSize = props.bsSize, children = props.children, className = props.className, data = props.data, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    debugEnabled = props.debug, disabled = props.disabled, emptyTemplate = props.emptyTemplate, footerTemplate = props.footerTemplate, id = props.id, _a = props.isOpen, isOpen = _a === void 0 ? false : _a, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    itemDisabled = props.itemDisabled, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    itemTemplate = props.itemTemplate, _b = props.menuPlacement, menuPlacement = _b === void 0 ? "bottom-start" : _b, minInline = props.minInline, enforceMenuPlacement = props.enforceMenuPlacement, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onMenuToggle = props.onMenuToggle, placeholder = props.placeholder, required = props.required, selectedItem = props.selectedItem, size = props.size, style = props.style, invalid = props.invalid, qaProp = props["data-qa"], tooltip = props.tooltip, valid = props.valid, otherProps = __rest(props, ["bsSize", "children", "className", "data", "debug", "disabled", "emptyTemplate", "footerTemplate", "id", "isOpen", "itemDisabled", "itemTemplate", "menuPlacement", "minInline", "enforceMenuPlacement", "name", "onBlur", "onChange", "onMenuToggle", "placeholder", "required", "selectedItem", "size", "style", "invalid", "data-qa", "tooltip", "valid"]);
    // Refs
    var inputRef = React.useRef(null);
    var selectRef = React.useRef(null);
    var menuRef = React.useRef(null);
    // State
    var _c = React.useState(isOpen), openState = _c[0], setOpenState = _c[1];
    var _d = React.useState([]), normalizedData = _d[0], setNormalizedData = _d[1];
    var _e = React.useState(), normalizedSelectedItem = _e[0], setNormalizedSelectedItem = _e[1];
    var _f = React.useState(), selectedItemState = _f[0], setSelectedItemState = _f[1];
    // Context
    var groupCtx = React.useContext(components_1.GKFormGroupContext);
    var isMobileSized = React.useContext(common_1.WindowSizeContext).isMobileSized;
    // Functions used internally and passed to the returned ref.
    var close = function () {
        setOpenState(false);
    };
    var closeAndFocusSelect = function () {
        var _a;
        close();
        (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var open = function () {
        if (!disabled) {
            setOpenState(true);
            if (menuRef && menuRef.current) {
                menuRef.current.focus();
            }
        }
    };
    var toggle = function () {
        if (openState) {
            close();
        }
        else {
            open();
        }
    };
    var selection = function () {
        if (data) {
            return selectedItemState;
        }
        else {
            return selectedItemState.value;
        }
    };
    React.useImperativeHandle(ref, function () {
        var select = selectRef.current;
        if (!select) {
            return {};
        }
        return {
            close: function () { return close(); },
            open: function () { return open(); },
            selection: function () { return selection(); },
            toggle: function () { return toggle(); },
            value: function () { return selection(); },
        };
    });
    (0, hooks_1.useActionOutsideElement)(selectRef, function (shouldClose) {
        if (openState && shouldClose && !isMobileSized) {
            close();
        }
    });
    // Helper function to return a safe 'selectedItem' prop.
    var getNormalizedSelectedItem = function () {
        if (selectedItem === undefined || !normalizedData) {
            return undefined;
        }
        if (data) {
            return selectedItem;
        }
        var matchedChild = new Grouping_1.Grouping("", normalizedData).findItem(function (item) {
            return item[0].value === selectedItem;
        })[0];
        return matchedChild ? matchedChild[0] : undefined;
    };
    // Parse children into a data structure with metadata.
    var parseChildren = function (childrenToParse) {
        var parsed = [];
        React.Children.forEach(childrenToParse, function (child) {
            if (child.type === components_1.GKOption || child.type === _1.GKSelectOption) {
                // const isSelected = isItemSelected( child.props );
                parsed.push([
                    child.props,
                    {
                        active: child.props.selected || false,
                        className: child.props.className,
                        "data-qa": child.props["data-qa"],
                        disabled: child.props.disabled || false,
                        onSelect: child.props.onSelect,
                        selectable: child.props.selectable === false ? false : true,
                        style: child.props.style,
                    },
                ]);
            }
            else if (child.type === components_1.GKOptgroup || child.type === _1.GKSelectOptgroup) {
                parsed.push(new Grouping_1.Grouping(child.props.label, parseChildren(child.props.children), {
                    className: child.props.className,
                    "data-qa": child.props["data-qa"],
                    style: child.props.style,
                }));
            }
        });
        return parsed;
    };
    // Effects
    React.useEffect(function () {
        setNormalizedData(data || parseChildren(children));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children, data]);
    React.useEffect(function () {
        var newSelectedItem = getNormalizedSelectedItem();
        var activeTuple = (normalizedData.length
            ? new Grouping_1.Grouping("", normalizedData).findItem(function (item) { return item[1] && item[1].active; })
            : [undefined])[0];
        var activeItem = activeTuple ? activeTuple[0] : undefined;
        setNormalizedSelectedItem(newSelectedItem !== undefined ? [newSelectedItem] : undefined);
        setSelectedItemState(newSelectedItem !== undefined ? newSelectedItem : activeItem);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedItem, normalizedData]);
    React.useEffect(function () {
        var _a;
        (_a = groupCtx.setDisabled) === null || _a === void 0 ? void 0 : _a.call(groupCtx, disabled);
    }, [groupCtx, disabled]);
    React.useEffect(function () {
        var _a;
        (_a = groupCtx.setValidation) === null || _a === void 0 ? void 0 : _a.call(groupCtx, invalid === true ? false : valid === true ? true : undefined);
    }, [groupCtx, invalid, valid]);
    React.useEffect(function () {
        groupCtx.setRequired(required);
    }, [groupCtx, required]);
    // Handle the onChange event.
    var handleChange = function (selectedArray) {
        setSelectedItemState(selectedArray[0]);
        closeAndFocusSelect();
        // If we have data, then we can pass back selected items as-is,
        // otherwise we're using children. Assert it as option props and extract the value.
        var selected = data
            ? selectedArray[0]
            : selectedArray[0].value;
        if (onChange) {
            onChange(selected);
        }
    };
    // Override for the item template to handle children.
    var itemTemplateOverride = function (item) {
        var renderedItem;
        if (data) {
            renderedItem = props.itemTemplate
                ? props.itemTemplate(item)
                : props.itemToString
                    ? props.itemToString(item)
                    : String(item);
        }
        else {
            var castItem = item;
            renderedItem = React.createElement("span", null, castItem.children || castItem.label);
        }
        return renderedItem;
    };
    // Returns the "label", the strigified / short text of an item, used in the select box.
    var getSelectBoxText = function () {
        if (selectedItemState !== undefined) {
            if (data) {
                return props.itemToString
                    ? props.itemToString(selectedItemState)
                    : String(selectedItemState);
            }
            var myItem = selectedItemState;
            return myItem.label || myItem.children;
        }
        return placeholder;
    };
    // Get the props for our container
    var containerProps = (0, hooks_1.useMergedProps)({ className: className, id: id, style: style, "data-qa": qaProp }, {
        _gkComponentIdentifier: "gk-select",
        className: "" + (openState ? "menu-open" : "menu-closed") + (minInline ? " form-control-min-inline" : ""),
    });
    // Get the className for our select box.
    var selectBoxClasses = [
        "gk-select-box",
        "d-flex",
        "form-control",
        disabled && "is-disabled",
        valid && "is-valid",
        invalid && "is-invalid",
        (bsSize || size) && "form-control-" + (bsSize || size),
    ]
        .filter(function (x) { return x; })
        .join(" ");
    var sel = selectedItemState && selection();
    var selVal = typeof sel === "string" ? sel : JSON.stringify(sel);
    // Render
    return (React.createElement("div", __assign({}, containerProps, { tabIndex: disabled ? -1 : 0, ref: selectRef, onBlur: onBlur }),
        React.createElement("div", { className: selectBoxClasses, onClick: toggle, "data-qa": containerProps["data-qa"] + "--summary" },
            React.createElement("span", { className: "gk-select-box-text my-auto" }, getSelectBoxText())),
        normalizedData.length || (!normalizedData.length && emptyTemplate) ? (React.createElement(components_1.GKSelectionMenu, __assign({ anchorRef: selectRef, autoFocus: false, data: normalizedData, "data-qa": containerProps["data-qa"] + "--menu", emptyTemplate: emptyTemplate, enforcePlacement: enforceMenuPlacement, footerTemplate: footerTemplate, isOpen: openState, itemTemplate: itemTemplateOverride, onChange: handleChange, onClose: closeAndFocusSelect, onMenuToggle: onMenuToggle, placement: menuPlacement, selection: normalizedSelectedItem }, otherProps, { ref: menuRef }))) : null,
        React.createElement(components_1.GKInput, { type: "hidden", name: name, value: selVal || "", innerRef: inputRef, "data-qa": containerProps["data-qa"] + "--input" }),
        tooltip && React.createElement(components_1.GKTooltip, { target: inputRef }, tooltip)));
};
exports.GKSelect = React.forwardRef(GKSelectDefinition);
exports.default = exports.GKSelect;
